import { countryPhoneData } from 'phone'
import React from 'react'

import { useTranslation } from '@flecto/translations'

import { CountryFlag } from './countryFlag'

export default function useSelectCountries(defaultValueOption = 'PT') {
  const {
    t,
    i18n: { language },
  } = useTranslation('shared', { keyPrefix: 'countries' })

  const countryPhone = React.useMemo(() => {
    return countryPhoneData.map((country) => {
      try {
        const flag = CountryFlag[country.alpha2 as keyof typeof CountryFlag]
        const label = `${flag} ${t(country.alpha2)}`
        return {
          value: country.alpha2,
          label,
        }
      } catch {
        return {
          value: country.alpha2,
          label: country.country_name,
        }
      }
    })
  }, [language])

  const defaultValue = React.useMemo(() => {
    return countryPhone.find((item) => item.value === defaultValueOption)
  }, [countryPhone])

  return { countries: countryPhone, defaultValue }
}
